// src/app/ProjectMaterial.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectMaterial } from  '../objects/Project';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectMaterialService {
    
  private apiUrl = environment.apiUrl +'ProjectMaterials'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  GetProjectMaterial(): Observable<ProjectMaterial[]> {
    return this.http.get<ProjectMaterial[]>(this.apiUrl);
  }

  
  getMaterial(id:number): Observable<ProjectMaterial> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<ProjectMaterial>(url);
  }



  addMaterial(material: ProjectMaterial): Observable<ProjectMaterial> {
    return this.http.post<ProjectMaterial>(this.apiUrl, material);
  }

  editMaterial(material: ProjectMaterial): Observable<ProjectMaterial> {
    const url = `${this.apiUrl}/${material.id}`;
    return this.http.put<ProjectMaterial>(url, material);
  }
  deleteMaterial(material: ProjectMaterial): Observable<ProjectMaterial> {
    const url = `${this.apiUrl}/${material.id}`;
    return this.http.delete<ProjectMaterial>(url);
  }
}
